const Preloader = () => (
    <div className="web-preloader">
        <h2>Loading...</h2>
    </div>
);

export default Preloader;
